import React, { useEffect, useState } from 'react';
import CursoLayout from '../layouts/CursosLayout';
import data from '../data/eficiencia.json';

const CursosIngles = () => {
    return (
    <CursoLayout data={data}/>
  )
}

export default CursosIngles